import { Link } from "react-router-dom";
import { ThemedItinerary } from "@/components/ThemedItinerary";
import { spotImg } from "@/data/planner";

const cfg = {
  testid: "like-a-local-page",
  seo: {
    title: "Copenhagen Like a Local: 3 Days for Returning Visitors",
    description:
      "Been to Copenhagen before? Skip the Little Mermaid and spend 3 days like a local — Nørrebro's Jægersborggade, Østerbro and Nordhavn, Refshaleøen and the Carlsberg district.",
    path: "/copenhagen-like-a-local",
  },
  heroBg: "#1B2A1E",
  heroImgId: "jaegersborggade",
  accent: "#E8B23A",
  eyebrow: "THE SECOND VISIT",
  h1: "Copenhagen",
  h1Italic: "like a local",
  intro:
    "Already seen Nyhavn, Tivoli and the Round Tower? This is the trip for the second visit — three days in the neighbourhoods Copenhageners actually spend their weekends: Nørrebro's coolest street, the pretty terraced lanes of Østerbro out to the new Nordhavn waterfront, and a Vesterbro-and-Carlsberg day of beer, street food and old breweries.",
  days: [
    {
      label: "DAY ONE",
      title: "Nordvest & Nørrebro —",
      titleAccent: "the coolest quarter",
      blurb:
        "Start furthest out and work back: the jaw-dropping yellow-brick Grundtvigs Kirke, the cherry-lined Bispebjerg cemetery, the wild Superkilen park, the food-and-design street Jægersborggade, the leafy old cemetery where Hans Christian Andersen is buried, buzzing Blågårdsgade for dinner — and a Diamond Slice to finish.",
      blurbNode: (
        <>
          Start furthest out and work back: the jaw-dropping yellow-brick Grundtvigs Kirke, the cherry-lined Bispebjerg cemetery, the
          wild Superkilen park, the food-and-design street Jægersborggade, the leafy old cemetery where{" "}
          <Link to="/hc-andersen" className="font-700 underline decoration-2 underline-offset-2 hover:text-black transition-colors" style={{ textDecorationColor: "#E8B23A" }}>
            Hans Christian Andersen
          </Link>{" "}
          is buried, buzzing Blågårdsgade for dinner — and a Diamond Slice to finish.
        </>
      ),
      ids: ["grundtvigs", "bispebjerg", "superkilen", "jaegersborggade", "assistens", "blaagaards", "diamondpizza"],
      extras: [
        "andersenmaillard",
        { name: "Rondo", note: "A beloved little Nørrebro bakery for cardamom buns and sourdough, at Sjællandsgade 7" },
      ],
    },
    {
      label: "DAY TWO",
      title: "Østerbro & Nordhavn —",
      titleAccent: "pretty streets & the new harbour",
      blurb:
        "A slow day in Copenhagen's calmest quarter: the historic Brumleby cottages, the colourful little street of Olufsvej, a pastry from Juno the Bakery, then north to the reclaimed Nordhavn waterfront — the Konditaget Lüders rooftop and a dip off Sandkaj in summer.",
      ids: ["brumleby", "olufsgade", "juno", "nordhavn", "swim-sandkaj"],
      notes: {
        "swim-sandkaj":
          "A sunny harbour-bath deck in Nordhavn — ladders straight into the ocean. If you aren't into swimming or the weather isn't cooperating, enjoy Nordhavn some more, then take the harbour bus from Orientkaj back to the city centre",
      },
      extras: ["bosses", "kartoffelraekkerne", "ismageriet"],
    },
    {
      label: "DAY THREE",
      title: "Vesterbro & Carlsberg —",
      titleAccent: "beer, street food & old breweries",
      blurb:
        "Copenhagen's hippest quarter: open at the Ny Carlsberg Glyptotek — ancient sculpture and a palm-filled winter garden under glass — then stroll Istedgade out to Enghave Plads, tour the historic Home of Carlsberg, wander the new Carlsberg Byen district, and end in Kødbyen, the old meatpacking district turned bar-and-restaurant hotspot.",
      ids: ["glyptoteket", "istedgade", "enghaveplads", "carlsberg", "carlsbergbyen", "koedbyen"],
      extras: ["kobenhavnsbageri", "gasolinegrill"],
    },
  ],
  cta: { title: "Make it your own?", titleItalic: "It loads straight into the planner" },
  shareTitle: "Copenhagen Like a Local — 3 Days for Returning Visitors",
  schemaName: "Copenhagen Like a Local — 3 Days for Returning Visitors",
  heroImg: spotImg("jaegersborggade", 1600),
  explore: [
    { label: "First time here? The classic 3-day itinerary", to: "/copenhagen-itinerary" },
    { label: "Explore by neighbourhood — the areas guide", to: "/areas" },
    { label: "Build your own version — the free planner", to: "/planner" },
  ],
};

export default function LikeALocalPage() {
  return <ThemedItinerary cfg={cfg} />;
}
